<template>
  <UiBox class="ui-box-apply" layout="single">
    <template v-slot:nav-left>
      <UiTab class="title">
        <i></i>
        <div class="label-box">
          <span class="label-shadow">战队报名</span>
          <span class="label-text">战队报名</span>
        </div>
      </UiTab>
    </template>
    <template v-slot:nav-right>
      <div class="right-box">
        <UiButton class="modal-btn calendar" colorType="red-complex" hook @click="appStore.openModal({ id: 'apply-calendar' })">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">赛程日历</span>
            <span class="label-text">赛程日历</span>
          </div>
        </UiButton>
        <UiButton class="modal-btn prize" colorType="red-complex" hook @click="appStore.openModal({ id: 'schedule-prize' })">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">奖金规则</span>
            <span class="label-text">奖金规则</span>
          </div>
        </UiButton>
        <UiButton class="modal-btn notice" colorType="red-complex" hook @click="appStore.openModal({ id: 'apply-notice' })">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">报名须知</span>
            <span class="label-text">报名须知</span>
          </div>
        </UiButton>
        <UiButton v-if="showFullRuleBtn" class="modal-btn rule" colorType="red-complex" hook @click="appStore.openModal({ id: 'apply-rule' })">
          <i></i>
          <div class="label-box">
            <span class="label-shadow">完整赛制</span>
            <span class="label-text">完整赛制</span>
          </div>
        </UiButton>
      </div>
    </template>
    <template v-slot:container>
      <div
        class="inner-container"
        :style="{
          'background-image': `url(${lg(config, 'registration_kv', '')})`
        }"
      >
        <div v-if="false" class="logos"></div>
        <div class="bottom-box">
          <UiButton class="btn" colorType="gold" @click="startApply">
            <div v-if="lg(Info, 'team_status', 0) === 0" class="label-box">
              <span class="label-shadow">开始报名</span>
              <span class="label-text">开始报名</span>
            </div>
            <div v-else class="label-box">
              <span class="label-shadow">查看报名状态</span>
              <span class="label-text">查看报名状态</span>
            </div>
          </UiButton>
        </div>
      </div>
    </template>

    <modal-rule />
    <modal-calendar />
    <modal-notice :agree="Info.agree" />
    <modal-prize :agree="Info.agree" />
  </UiBox>
</template>

<script setup>
import { computed, inject } from 'vue'
import { useAppStore } from '@/store'
import { usePrompt } from '@/composables/usePrompt'
import { useStageStore, REGISTRATION_WINDOW } from '@/store/stage'
import lg from '@/utils/lg'
import { useConfig, useConfigFlag } from '@/composables/useConfig'
import UiBox from '@/components/ui-box'
import UiTab from '@/components/ui-tab';
import UiButton from '@/components/ui-button';
import ModalRule from './modal/rule'
import ModalCalendar from './modal/calendar'
import ModalNotice from './modal/notice'
import ModalPrize from '@/views/schedule/prize'

const handleStep = inject('handleStep')
const apply_info = inject('apply_info')
const { showPrompt: promptMsg } = usePrompt()

const appStore = useAppStore()
const stageStore = useStageStore()


const token = computed(() => appStore.token)
const config = useConfig()
const Info = computed(() => apply_info())

const showFullRuleBtn = useConfigFlag('season_rule_show')





function startApply() {
  if (!token.value) {
    promptMsg('未检测到token')
    return
  }

  // 如果已报名, 直接检查报名进度
  if (lg(Info.value, 'team_status', 0) > 0) {
    handleStep(5)
  } else {
    // 未报名状态下, 由 stage store 统一判断报名时间窗
    const registrationWindow = stageStore.getRegistrationWindow()
    if (registrationWindow === REGISTRATION_WINDOW.PENDING) {
      promptMsg('报名未开启')
    } else if (registrationWindow === REGISTRATION_WINDOW.OPEN) {
      // --- 报名开启 ---
      // 未同意报名须知，打开报名须知
      if (!Info.value.agree) {
        appStore.openModal({ id: 'apply-notice' })
      } else {
        handleStep(2)
      }
    } else {
      promptMsg('报名已结束')
    }
  }

  // 埋点
  if (typeof tapdb === 'undefined') return
  tapdb.trackEvent('点击报名')
}
</script>

<style lang="scss" scoped>
.title {
  font-weight: 500;
  i {
    position: relative;
    @include r(width, 36);
    @include r(height, 36);
    @include icon_status('apply_1');
    margin-right: get_vh(8);
  }
  .label-box {
    .label-shadow {
      color: #A31813;
    }
    .label-text {
      color: #FFFFFF;
    }
  }
}

.right-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  .modal-btn {
    @include r(width, 130);
    @include r(height, 40);
    @include r(font-size, 20);
    @include r(margin-left, 10);
    -webkit-tap-highlight-color: transparent;
    cursor: pointer;
    @include boxShadowSet_Btn;
    i {
      display: inline-block;
      @include r(width, 25);
      @include r(height, 25);
      @include r(margin-right, 5);
    }
  }
  .modal-btn.rule {
    i {
      @include icon_status('btn_match');
    }
  }
  .modal-btn.calendar {
    i {
      @include icon_status('btn_calendar');
    }
  }
  .modal-btn.notice {
    i {
      @include icon_status('btn_apply');
    }
  }
  .modal-btn.prize {
    i {
      @include icon_status('btn_reward');
    }
  }
}

:deep(.ui-box-container) {
  width: unset !important;
  height: unset !important;
  inset: 14.4% 1.9% 4.9% 1.9%;
}

.inner-container {
  position: relative;
  @include r(width, 1385);
  @include r(height, 573);
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  overflow: hidden;
  // @include boxShadowSet_Container;
  // .logos{
  //  position: absolute;
  //  top: get_vh(8);
  //  left: get_vh(18);
  //  background-image: url('https://website.xdcdn.net/poster/58881/20250717/K6fc83RN.png');
  //  background-size: contain;
  //  background-position: left center;
  //  background-repeat: no-repeat;
  //  width: get_vw(210);
  //  height: get_vw(63);
  // }
  .bottom-box {
    position: absolute;
    bottom: 0;
    width: 100%;
    @include r(height, 124);
    display: flex;
    justify-content: center;
    align-items: center;
    .btn {
      @include r(width, 266);
      @include r(height, 71);
      @include r(font-size, 30);
      font-weight: bold;
      // @include boxShadowSet_Btn;
      cursor: pointer;
      -webkit-tap-highlight-color: transparent;
      &:active {
        opacity: 0.9;
      }
    }
  }
}
</style>
